import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Login from './pages/Login';
import WeeklyReportBoard from './pages/WeeklyReportBoard';
import Admin from './pages/Admin';
import Layout from './components/Layout';
import { AuthProvider, useAuth } from './context/AuthContext';

// 인증 가드 컴포넌트
const AuthGuard = () => {
  const { isAuth } = useAuth();
  
  if (!isAuth) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          {/* 보호된 라우트: 인증이 필요한 페이지 */}
          <Route element={<AuthGuard />}>
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<WeeklyReportBoard />} />
              <Route path="/admin" element={<Admin />} />
            </Route>
          </Route>

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
